module.exports = __webpack_public_path__ + "files/8bac22ed4fd7c8a30536be18e2984f84.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-800.ttf
// module id = 878
// module chunks = 60